<script>
import AdminLayout from '@layouts/admin-main'
import ActivityLogList from '@components/admin/activity-log-list'

export default {
  page: {
    title: 'Admin::ActivityLogList',
    meta: [{ name: 'description', content: 'Admin::ActivityLogList' }],
  },
  components: { AdminLayout, ActivityLogList },
}
</script>

<template>
  <AdminLayout>
    <ActivityLogList></ActivityLogList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
